export default __webpack_public_path__ + "static/media/shipping.d06166fe.webp";